import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { setopenmain, setvista, setfeature } from "../../state/actions";

import { Link } from "gatsby";

//import BloccoCapoCamicia from "../bloccoCapo/bloccocapocamicia";

import logo from "../../images/logo.png";

import LanguageSelector from "../LanguageSelector";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";

const Header = (props) => {
  const {
    lingua,

    setFeature,
    feature,

    urlCorrente,
    giaccaUrl,
    pantaloneUrl,
  } = props;

  const [open, setOpen] = useState(false);

  const [itemsCount, setItemsCount] = useState(0);

  useEffect(() => {
    window.Snipcart.ready.then(function () {
      const initialState = window.Snipcart.store.getState();
      setItemsCount(initialState.cart.items.count);

      const unsubscribe = window.Snipcart.store.subscribe(() => {
        const newState = window.Snipcart.store.getState();
        setItemsCount(newState.cart.items.count);
      });

      return () => unsubscribe();
    });
  }, [setItemsCount]);

  return (
    <>
      <nav
        className="navbar is-transparent has-background-grey-paky"
        role="navigation"
        aria-label="main navigation"
      >
        <div className="container paky-fluid-container">
          <div className="navbar-brand">
          <Link to="/" className="navbar-item">
            <img src={logo} alt="Logo Bellicoso" />
          </Link>

            <Tooltip title={lingua.header.account}>
              <IconButton
                size="large"
                aria-label="Account"
                color="inherit"
                className="navbar-item is-hidden-desktop snipcart-customer-signin"
              >
                <ManageAccountsIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title={lingua.header.shopping}>
              <IconButton
                size="large"
                aria-label="Carrello"
                color="inherit"
                className="navbar-item is-hidden-desktop snipcart-checkout"
              >
                <Badge badgeContent={itemsCount} color="info">
                  <ShoppingCartIcon />
                </Badge>
              </IconButton>
            </Tooltip>

            <a
              role="button"
              class="navbar-burger"
              aria-label="menu"
              aria-expanded="false"
              data-target="navbarBasicExample"
              onClick={() => setOpen(true)}
            >
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
          </div>

          <div className="navbar-menu">
            <div className="navbar-start is-hidden-desktop-only is-hidden-touch">
              <button
                style={{
                  border: "none",
                  cursor: "pointer",
                }}
                className={
                  feature === 1
                    ? "navbar-item is-active has-background-white is-uppercase"
                    : "navbar-item has-background-grey-paky is-uppercase"
                }
                onClick={() => setFeature(1)}
              >
                {lingua.navigazione.tessuto}
              </button>

              <button
                style={{
                  border: "none",
                  cursor: "pointer",
                }}
                className={
                  feature === 2
                    ? "navbar-item is-active has-background-white is-uppercase"
                    : "navbar-item has-background-grey-paky is-uppercase"
                }
                onClick={() => setFeature(2)}
              >
                {lingua.navigazione.personalizzazione}
              </button>

              <button
                style={{
                  border: "none",
                  cursor: "pointer",
                }}
                className={
                  feature === 3
                    ? "navbar-item is-active has-background-white is-uppercase"
                    : "navbar-item has-background-grey-paky is-uppercase"
                }
                onClick={() => setFeature(3)}
              >
                {lingua.navigazione.misure.misure}
              </button>
            </div>

            <div className="navbar-end">
              {/*<BloccoCapoCamicia urlCorrente={urlCorrente} lingua={lingua} giaccaUrl={giaccaUrl} pantaloneUrl={pantaloneUrl} />*/}

              <Tooltip title={lingua.header.account}>
                <IconButton
                  size="large"
                  aria-label="Account"
                  color="inherit"
                  className="navbar-item snipcart-customer-signin"
                >
                  <ManageAccountsIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title={lingua.header.shopping}>
                <IconButton
                  size="large"
                  aria-label="Carrello"
                  color="inherit"
                  className="navbar-item snipcart-checkout"
                >
                  <Badge badgeContent={itemsCount} color="info">
                    <ShoppingCartIcon />
                  </Badge>
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </div>
      </nav>

      <Drawer
        anchor={"right"}
        open={open}
        onClose={() => setOpen(false)}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          width: 320,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 320,
            boxSizing: "border-box",
          },
        }}
      >
        <div className="p-3">
          <button
            className="button is-small is-white is-pulled-right"
            onClick={() => setOpen(false)}
          >
            <span className="icon">
              <CloseIcon />
            </span>
          </button>
          <aside className="section menu">
            <ul className="menu-list">
              <li>
                <Link to="/" activeStyle={{ color: "#666" }}>
                  Home
                </Link>
              </li>

              {/**
                <li>
                  <Link
                    to="/shop/"
                    activeStyle={{ color: "#666" }}
                    
                  >
                    Shop
                  </Link>
                </li>
 */}

              <li>
                <Link to="/privacy-policy/" activeStyle={{ color: "#666" }}>
                  {lingua.footer.privacy}
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy/" activeStyle={{ color: "#666" }}>
                  {lingua.footer.cookie}
                </Link>
              </li>
              {/**
                <li>
                  <Link
                    to="/withdrawal/"
                    activeStyle={{ color: "#666" }}
                    onClick={() => setActive("")}
                  >
                    {lingua.footer.recesso}
                  </Link>
                </li>
                */}
              {/**
                <li>
                  <Link
                    to="/terms/"
                    activeStyle={{ color: "#666" }}
                    onClick={() => setActive("")}
                  >
                    {lingua.footer.termini}
                  </Link>
                </li>
              */}
              <li>
                <Link to="/" activeStyle={{ color: "#666" }}>
                  {lingua.footer.contattaci}
                </Link>
              </li>
              <hr />
              <li>
                <LanguageSelector />
              </li>
            </ul>
          </aside>
        </div>
      </Drawer>
    </>
  );
};

function mapStateToProps(state) {
  return {
    vista: state.shop.vista,

    camiciaUrl: state.shop.camicia.urlCorrente,
    giaccaUrl: state.shop.giacca.urlCorrente,
    pantaloneUrl: state.shop.pantalone.urlCorrente,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setFeature: (val) => dispatch(setfeature(val)),
    setOpenMain: (val) => dispatch(setopenmain(val)),
    setVis: (val) => dispatch(setvista(val)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
